import moment from 'moment';

const validateNumber = (value, type) => {
    const num = Number(value);
    if (type === 'integer' && Number.isInteger(num) && num >= 0) {
        return true;
    }

    if (type === 'number' && num >= 0) {
        return true;
    }

    return type === 'string';
};

const validateInputValue = (value, type) => {
    const x = parseFloat(value);
    if (type === 'percentage') {
        return !(isNaN(x) || x < 0 || x > 100);
    } else if (type === 'minutes') {
        return !(isNaN(x) || x < 0 || x > 60);
    } else if (type === 'hours') {
        return !(isNaN(x) || x < 0 || x > 24);
    } else {
        return !(isNaN(x) || x < 0 || x > 255);
    }
};

const validateEmail = (email) => {
    return email.match(
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

const validatePassword = (password) => {
    const re = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,20}$/;
    return re.test(password);
};

const handleDeviceColumns = (data) => {
    const columns_order = [];
    const columns_visibility = {};
    for (let i = 0; i < data.length; i++) {
        let columnWidth = 150;
        if (
            data[i].column_name === 'os_ver' ||
            data[i].column_name === 'os_name' ||
            data[i].column_name === 'proc' ||
            data[i].column_name === 'disp_1_nm' ||
            data[i].column_name === 'disp_2_nm' ||
            data[i].column_name === 'sys_type' ||
            data[i].column_name === 'manufacturer' ||
            data[i].column_name === 'version' ||
            data[i].column_name === 'username' ||
            data[i].column_name === 'islicensed' ||
            data[i].column_name === 'isportable' ||
            data[i].column_name === 'groupid_id'
        ) {
            columnWidth = 100;
        }
        if (data[i].column_visibility === true) {
            columns_order.push({
                field: data[i].column_name,
                headerName: data[i].header_name,
                sortable: true,
                resizable: true,
                headerClassName: 'device-column-header',
                width: columnWidth
            });
        }
        columns_visibility[data[i].column_name] = data[i].column_visibility;
    }
    return [columns_order, columns_visibility];
};

const handleUpdateReportDateRange = (value) => {
    const today = new Date();
    let startDate;
    if (value === '1week') {
        startDate = today.setDate(today.getDate() - 7);
    } else if (value === '2weeks') {
        startDate = today.setDate(today.getDate() - 14);
    } else if (value === '1month') {
        startDate = today.setMonth(today.getMonth() - 1);
    } else if (value === '3months') {
        startDate = today.setMonth(today.getMonth() - 3);
    } else if (value === '6months') {
        startDate = today.setMonth(today.getMonth() - 6);
    } else if (value === '1year') {
        startDate = today.setFullYear(today.getFullYear() - 1);
    } else {
        startDate = today;
    }
    return startDate;
};

const convertDate = (value) => {
    if (value.$d) {
        return moment(value.$d).format('YYYY-MM-DD');
    } else {
        return moment(value).format('YYYY-MM-DD');
    }
};

export {
    validateNumber,
    validateInputValue,
    validateEmail,
    validatePassword,
    handleDeviceColumns,
    handleUpdateReportDateRange,
    convertDate
};
